import { tr } from 'mmfintech-commons'
import settings from '@settings'

export const IframeOtp = ({ operationId, type, challenge = '', sentTo = '' }) => {
  return (
    <iframe
      title={tr('FRONTEND.INDEX.OTP_CHALLENGE', 'OTP Challenge')}
      src={`${settings.cardsUrl}challenge?type=${type}&id=${operationId}${challenge ? `&challenge=${challenge}` : ''}${sentTo ? `&sentTo=${encodeURIComponent(sentTo)}` : ''}`}
      allow='clipboard-read; clipboard-write'
      onLoad={async () => {}}
    />
  )
}
